import { IsObject } from '../../helpers';
import { READONLY_TUPLE_PRIVATE } from './privates';
import { ConstructClassWithPrivateMembers } from '../helpers/ClassWithPrivateMembers';
export function ConstructReadonlyTuple(instance, tuple) {
    ConstructClassWithPrivateMembers(instance, READONLY_TUPLE_PRIVATE);
    if (Array.isArray(tuple)) {
        instance[READONLY_TUPLE_PRIVATE].items = tuple;
    }
    else {
        throw new TypeError(`Expected array as tuple`);
    }
}
export function IsReadonlyTuple(value) {
    return IsObject(value)
        && value.hasOwnProperty(READONLY_TUPLE_PRIVATE);
}
//# sourceMappingURL=constructor.js.map